// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-ctr {
  display: inline-block;
  position: relative;
  overflow: hidden;
  width: 32px;
  height: 32px;
  top: 12px;
  margin: 0 10px;
}

.spinner {
  pointer-events: none;
  width: 14px;
  height: 14px;
  border: 8px solid transparent;
  border-color: #eee;
  border-top-color: #aaa;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/resources/elements/spinner/spinner.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AACJ;;AAEA;EACC,oBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;AACD;;AAEA;EACC;IACE,yBAAA;EACD;AACF","sourcesContent":[".spinner-ctr {\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n    width: 32px;\n    height: 32px;\n    top: 12px;\n    margin: 0 10px;\n}\n\n.spinner {\n\tpointer-events: none;\n\twidth: 14px;\n\theight: 14px;\n\tborder: 8px solid transparent;\n\tborder-color: #eee;\n\tborder-top-color: #aaa;\n\tborder-radius: 50%;\n\tanimation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n\t100% {\n\t\t\ttransform: rotate(360deg)\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
